import { SpendDates } from './spend-dates';
import { RfpBuyerIdentifier } from './buyer-identifier';

export class SpendByParticipants {
  actualSpend!: number;
  continuedSpend!: number;
  spendDates!: SpendDates;
  unitsPurchased!: number;
  buyer!: RfpBuyerIdentifier;

  constructor(data: unknown) {
    Object.assign(this, data);
    // Overide these with the Date versions for easier coding elsewhere
    if (this.spendDates?.startDate) {
      this.spendDates.startDate = new Date(this.spendDates.startDate);
    }
    if (this.spendDates?.endDate) {
      this.spendDates.endDate = new Date(this.spendDates.endDate);
    }
  }
}
